module.exports = __webpack_public_path__ + "img/thinkparq.7f8cb4af.svg";